"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthMobileInterceptor = void 0;
const AbstractAuthInterceptor_1 = require("../Interceptor/AbstractAuthInterceptor");
const TokenMobileModel_1 = require("../Model/TokenMobileModel");
class AuthMobileInterceptor extends AbstractAuthInterceptor_1.AbstractAuthInterceptor {
    constructor(authClient, data) {
        super(authClient);
        this.authClient = authClient;
        this.tokenModel = new TokenMobileModel_1.TokenMobileModel(data);
    }
}
exports.AuthMobileInterceptor = AuthMobileInterceptor;
//# sourceMappingURL=AuthMobileInterceptor.js.map